const COMIDAS_BASE = ['desayuno', 'almuerzo', 'merienda', 'cena']

export function aISO(d) { return d.toISOString().split('T')[0] }

// created_at es un timestamptz en UTC — slicearlo directo da la fecha UTC,
// no la fecha calendario local (mismo bug de timezone ya fixeado en #43
// para el cálculo de "hoy": de noche en Argentina, UTC ya cayó al día
// siguiente).
export function fechaLocalDeTimestamp(ts) {
  const d = new Date(ts)
  return aISO(new Date(d.getFullYear(), d.getMonth(), d.getDate()))
}

export function diaCompleto(comidasDelDia) {
  return COMIDAS_BASE.every(tipo => {
    const c = (comidasDelDia ?? []).find(x => x.tipo_comida === tipo)
    if (!c) return false
    return (c.descripcion && c.descripcion.trim() !== '') || c.realizada === false
  })
}

export function habitoCumplido(config, fecha, controlDiario, checksHabitos) {
  if (config.habitos_catalogo.tipo === 'personalizado') {
    return checksHabitos[`${config.id}:${fecha}`] === true
  }
  const campo = config.habitos_catalogo.campo_referencia
  const fila = controlDiario[fecha]
  if (!fila) return false
  if (campo === 'comidas') return diaCompleto(fila.registro_comidas)
  const valor = fila[campo]
  if (valor == null) return false
  return config.meta_valor != null ? valor >= config.meta_valor : valor > 0
}

// Suplementos entran a la misma grilla que Hábitos (decisión del Bloque de
// hoy, Suplementos): una sola tabla mezclada, no una segunda tabla aparte.
// Esta función normaliza ambos modelos de datos (habitos_config y
// suplementos_config, con sus respectivas tablas de registro diario) a una
// forma común. Compartida entre Habitos.js (grilla) e Inicio.js (resumen
// "Hoy cumpliste X hábitos") a propósito — un cálculo propio en Inicio.js
// se había quedado sin sumar suplementos porque no reusaba esta función.
export function combinarItemsTracking(habitosActivos, suplementosActivos, controlDiario, checksHabitos, checksSuplementos, desactivarHabito) {
  const itemsHabitos = habitosActivos.map(config => ({
    id: `habito:${config.id}`,
    tipo: config.habitos_catalogo.tipo === 'personalizado' ? 'habito_manual' : 'habito_automatico',
    nombre: config.habitos_catalogo.nombre,
    fechaDesde: config.semana_inicio,
    tildable: config.habitos_catalogo.tipo === 'personalizado',
    cumplido: fecha => habitoCumplido(config, fecha, controlDiario, checksHabitos),
    idRegistro: config.id,
    onDesactivar: desactivarHabito ? () => desactivarHabito(config.id) : null
  }))
  const itemsSuplementos = suplementosActivos.map(s => ({
    id: `suplemento:${s.id}`,
    tipo: 'suplemento',
    nombre: s.suplementos_catalogo?.nombre || 'Suplemento',
    fechaDesde: fechaLocalDeTimestamp(s.created_at),
    tildable: true,
    cumplido: fecha => checksSuplementos[`${s.id}:${fecha}`] === true,
    idRegistro: s.id,
    onDesactivar: null
  }))
  return [...itemsHabitos, ...itemsSuplementos]
}
